"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useChartsData = void 0;
const capitalize_1 = __importDefault(require("lodash/capitalize"));
const next_i18next_1 = require("next-i18next");
const libs_context_device_type_1 = require("@hotelplan/libs.context.device-type");
const CHARTS_ORDER = [
    'MAX_TEMPERATURE_PER_MONTH',
    'SUN_HOURS_PER_MONTH',
    'WATER_TEMPERATURE_PER_MONTH',
    'RAIN_DAYS_PER_MONTH',
];
const MONTHS = [
    'JANUARY',
    'FEBRUARY',
    'MARCH',
    'APRIL',
    'MAY',
    'JUNE',
    'JULY',
    'AUGUST',
    'SEPTEMBER',
    'OCTOBER',
    'NOVEMBER',
    'DECEMBER',
];
const useChartsData = (charts, chartParamsCommon, chartParamsByType, chartColors) => {
    const [t] = (0, next_i18next_1.useTranslation)('common');
    const { mobile } = (0, libs_context_device_type_1.useDeviceType)();
    if (!charts) {
        return [];
    }
    const sortedCharts = CHARTS_ORDER.map(item => {
        return charts.find(chart => item === chart.type);
    }).filter(Boolean);
    return sortedCharts.map(chart => {
        const data = MONTHS.map((month, monthIndex) => ({
            name: t(`month.shorten.${(0, capitalize_1.default)(month)}`),
            value: chart.entries ? chart.entries[monthIndex].value : 0,
            lineValue: chart.entries ? chart.entries[monthIndex].value * 0.9 : 0,
        }));
        return Object.assign(Object.assign({}, chart), { data, colors: chartColors[chart.type || 'default'], params: Object.assign(Object.assign({}, chartParamsCommon[mobile ? 'mobile' : 'desktop']), chartParamsByType[chart.type]) });
    });
};
exports.useChartsData = useChartsData;
//# sourceMappingURL=useChartsData.js.map